import { makeAutoObservable } from 'mobx';

export class UIStore {
  drawerOpen = true;

  constructor(root) {
    this.root = root;
    makeAutoObservable(this, { root: false });
  }
}
